import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import Table from '../../components/common/Table';
import SmallButton from '../../components/common/SmallButton';
import axios from 'axios';
import swal from 'sweetalert2';

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(4px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const MobileMenuBtn = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    background: #1c1c1e;
    border-radius: 10px;
    color: #f5f5f7;
    cursor: pointer;
    flex-shrink: 0;
  }
`;

const Container = styled.div`
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  height: 94vh;
  overflow: scroll;
  width: 100%;
  margin: 16px 16px 16px 0;
  padding: 24px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.04), 0 4px 20px rgba(0, 0, 0, 0.06);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 768px) {
    height: 100vh;
    margin: 0;
    border-radius: 0;
    padding: 16px;
    justify-content: flex-start;
  }
`;
const Button = styled.button`
  display: inline-block;
  width: 60px;
  height: 30px;
  background-color: #f5f5f7;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
  border: none;
  color: #000;
  font-size: 15px;
  font-weight: 600;
  outline: none;
  cursor: pointer;
  :hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }
`;

const ProductCategoryPage = () => {
  const [manus, setManus] = useState();

  const _handleModify = async (id) => {
    const { value: name } = await swal.fire({
      title: '변경할 이름을 입력해 주세요.',
      input: 'text',
      confirmButtonText: '확인',
      cancelButtonText: '취소',
      confirmButtonColor: '#232323',
      cancelButtonColor: '#a3a3a3',
      inputValue: '',
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return '입력된 값이 없습니다.';
        }
      },
    });
    if (name) {
      try {
        const res = await axios.patch(`/admin/manufacturer/update/${id}`, {
          main_category: name,
        });
        if (res.status === 200) {
          swal.fire({
            text: '변경이 완료되었습니다.',
            icon: 'success',
            showConfirmButton: false,
            timer: 1000,
          });
          getManufacturer();
        }
      } catch (e) {
        swal.fire({
          width: 400,
          text: '오류가 발생했습니다.',
          icon: 'error',
          showConfirmButton: false,
          timer: 1000,
        });
      }
    }
  };

  const _handleDelete = (id) => {
    swal
      .fire({
        title: '정말 제조사를 삭제하시겠습니까?',
        text: '해당 제조사의 모든 제품은 삭제됩니다.',
        icon: 'warning',
        iconColor: '#d33',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#a8a8a8',
        confirmButtonText: '확인',
        cancelButtonText: '취소',
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          try {
            const res = await axios.delete(`/admin/manufacturer/delete/${id}`);
            if (res.status === 200) {
              swal.fire({
                text: '제품 삭제가 완료되었습니다.',
                icon: 'success',
                showConfirmButton: false,
                timer: 1000,
              });
              getManufacturer();
            }
          } catch (e) {
            swal.fire({
              position: 'top-end',
              width: 400,
              text: '오류가 발생했습니다.',
              icon: 'error',
              showConfirmButton: false,
              timer: 1000,
            });
          }
        }
      });
  };
  const _handleCreate = async () => {
    const value = await swal.fire({
      title: '추가할 제조사를 입력해 주세요.',
      input: 'text',
      confirmButtonText: '확인',
      cancelButtonText: '취소',
      confirmButtonColor: '#232323',
      cancelButtonColor: '#a3a3a3',
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return '입력된 값이 없습니다.';
        }
      },
    });
    if (value) {
      try {
        const res = await axios.post(`/admin/manufacturer/`, {
          main_category: value.value,
        });
        if (res.status === 200) {
          swal.fire({
            text: '성공적으로 추가되었습니다.',
            icon: 'success',
            showConfirmButton: false,
            timer: 1000,
          });
          getManufacturer();
        }
      } catch (e) {
        swal.fire({
          width: 400,
          text: '오류가 발생했습니다.',
          icon: 'error',
          showConfirmButton: false,
          timer: 1000,
        });
      }
    }
  };

  const getManufacturer = async () => {
    try {
      let { data: res } = await axios.get('/admin/manufacturer');
      res.map((r) => {
        const url = '/product/category/' + r.main_category;
        const id = r._id;
        delete r._id;
        r.detail = <SmallButton text="보기" url={url} />;
        r.modify = <Button onClick={() => _handleModify(id)}>변경</Button>;
        r.delete = <Button onClick={() => _handleDelete(id)}>삭제</Button>;
      });
      setManus(res);
    } catch (e) {
      console.log(e, 'getList');
    }
  };

  const titles = ['제조사', '보기', '수정', '삭제'];
  const button = (
    <Button
      style={{ width: '80px', height: '40px', backgroundColor: '#a3a3a3' }}
      onClick={() => _handleCreate()}
    >
      추가
    </Button>
  );
  useEffect(() => {
    getManufacturer();
  }, []);

  return (
    <Container>
      <div style={{ width: '100%', marginBottom: 8, display: 'flex', alignItems: 'center', gap: 10 }}>
        <MobileMenuBtn onClick={() => window.dispatchEvent(new Event('open-sidebar'))}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
            <line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </MobileMenuBtn>
        <h2 style={{ fontSize: 20, fontWeight: 700, color: '#111827', margin: 0 }}>제조사 조회</h2>
      </div>
      {manus && (
        <Table
          caption="제조사 조회"
          titles={titles}
          data={manus}
          button={button}
        />
      )}
    </Container>
  );
};

export default ProductCategoryPage;
